import { useAccountBalances, useAccountTopups } from '@/src/api/payg';
import {
  LoadingSpinner,
  PageWithNavigationAndSectionPadding,
} from '@/src/components';
import { PAYG_EVENTS } from '@/src/constants/analytics';
import { ROUTE_PAYG_TOPUP_DETAIL } from '@/src/constants/routes';
import AnalyticsService from '@/src/services/analyticsService';
import { getErrorDetails } from '@/src/utils/errorUtils';
import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom-v5';
import { ErrorView } from './components/ErrorView';
import { NoTransactionsView } from './components/NoTransactionsView';
import { TopupHistoryList } from './components/TopupHistoryList';
import { buildMsnFuelMap, groupTopupsByMonth } from './utils';

export const PAGE_TITLE = 'Top-up history';

export const PAYGTopupHistoryPage = () => {
  const history = useHistory();
  const topups = useAccountTopups();
  const balances = useAccountBalances();

  useEffect(() => {
    AnalyticsService.dispatch(...PAYG_EVENTS.topupHistoryViewed());
  }, []);

  useEffect(() => {
    if (topups.error) {
      const { code, message } = getErrorDetails(topups.error);
      AnalyticsService.dispatch(
        ...PAYG_EVENTS.topupHistoryError({
          code,
          message,
          source: 'topups',
        }),
      );
    }
    if (balances.error) {
      const { code, message } = getErrorDetails(balances.error);
      AnalyticsService.dispatch(
        ...PAYG_EVENTS.topupHistoryError({
          code,
          message,
          source: 'balances',
        }),
      );
    }
  }, [topups.error, balances.error]);

  useEffect(() => {
    if (topups.data?.length !== undefined) {
      AnalyticsService.dispatch(
        ...PAYG_EVENTS.topupHistoryTransactionsViewed({
          count: topups.data.length,
        }),
      );
    }
  }, [topups.data?.length]);

  if (topups.isLoading || balances.isLoading) {
    return (
      <PageWithNavigationAndSectionPadding title={PAGE_TITLE}>
        <LoadingSpinner />
      </PageWithNavigationAndSectionPadding>
    );
  }

  if (topups.isError || balances.isError || !topups.data || !balances.data) {
    return (
      <PageWithNavigationAndSectionPadding title={PAGE_TITLE}>
        <ErrorView />
      </PageWithNavigationAndSectionPadding>
    );
  }

  // TODO: Placeholder UI. Checking what we need to do here
  if (topups.data.length === 0) {
    return (
      <PageWithNavigationAndSectionPadding title={PAGE_TITLE}>
        <NoTransactionsView />
      </PageWithNavigationAndSectionPadding>
    );
  }

  const msnFuelMap = buildMsnFuelMap(balances.data.balances);

  return (
    <PageWithNavigationAndSectionPadding title={PAGE_TITLE}>
      <TopupHistoryList
        groups={groupTopupsByMonth(topups.data)}
        msnFuelMap={msnFuelMap}
        onClickView={item =>
          history.push({
            pathname: ROUTE_PAYG_TOPUP_DETAIL,
            state: { topup: item, fuel: msnFuelMap[item.msn] },
          })
        }
      />
    </PageWithNavigationAndSectionPadding>
  );
};
